import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "texto"
}
const _hoisted_2 = {
  key: 1,
  class: "texto sr-only"
}
const _hoisted_3 = ["disabled"]

import { nextTick, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { RecargaDeSessaoFalhouError, useAuthStore } from '@/stores/AuthStore';
import { rotaInicialDoPerfil } from '@/utils/rotaInicialDoPerfil';


export default /*@__PURE__*/_defineComponent({
  __name: 'TarjaDeAcessoComoOutro',
  setup(__props) {

const authStore = useAuthStore();
const router = useRouter();
const route = useRoute();
const voltando = ref(false);
const erro = ref<string | null>(null);
const confirmacaoVolta = ref<string | null>(null);
const statusEl = ref<HTMLElement | null>(null);
const erroEl = ref<HTMLElement | null>(null);

// A tarja mora no App.vue e nunca desmonta — sem isto, um erro nascido numa
// tela ficaria "grudado" no topo de todas as seguintes até o próximo clique
// ou F5, competindo com o conteúdo real a cada navegação. `route` some em
// teste sem router (useRoute() retorna undefined); a checagem opcional
// evita quebrar o watcher nesse caso.
watch(
  () => route?.fullPath,
  () => {
    erro.value = null;
    confirmacaoVolta.value = null;
  }
);

async function voltar(): Promise<void> {
  if (voltando.value) return;
  voltando.value = true;
  erro.value = null;

  try {
    await authStore.voltarAoMeuUsuario();

    // Navega para o destino correspondente ao perfil de quem voltou.
    // Tratamos o roteamento em bloco interno para que eventuais redirecionamentos
    // ou no-ops de rota não interfiram no sucesso da restauração de credencial.
    const destino = rotaInicialDoPerfil(authStore.activeRole || authStore.getDefaultRole());
    if (router) {
      try {
        const rotaAtual = router.currentRoute?.value;
        const rotaDestino = router.resolve(destino);
        if (rotaAtual && (rotaAtual.path === rotaDestino.path || rotaAtual.name === rotaDestino.name)) {
          router.go(0);
        } else {
          await router.push(destino);
        }
      } catch (navErr) {
        console.warn('Navegação após retorno ao perfil original:', navErr);
      }
    }
    await nextTick();

    confirmacaoVolta.value = `Você voltou a ser ${authStore.user?.name}.`;
    await nextTick();
    statusEl.value?.focus();
  } catch (err) {
    if (err instanceof RecargaDeSessaoFalhouError) {
      erro.value = `${err.message} Faça login novamente.`;
      await nextTick();
      erroEl.value?.focus();
    } else {
      erro.value = 'Não foi possível voltar ao seu usuário agora. Tente novamente.';
    }
  } finally {
    voltando.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tarja-wrapper", { 'tarja-wrapper--ativa': _unref(authStore).acessandoComo }])
  }, [
    _createElementVNode("div", {
      ref_key: "statusEl",
      ref: statusEl,
      class: "tarja-live",
      role: "status",
      tabindex: "-1"
    }, [
      (_unref(authStore).acessandoComo)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
            _cache[0] || (_cache[0] = _createTextVNode(" Você está usando o sistema como ")),
            _createElementVNode("strong", null, _toDisplayString(_unref(authStore).user?.name), 1),
            _cache[1] || (_cache[1] = _createTextVNode(", conectado como ")),
            _createElementVNode("strong", null, _toDisplayString(_unref(authStore).nomeDoImpersonador), 1),
            _cache[2] || (_cache[2] = _createTextVNode(". Esta credencial temporária dura 2 horas; passado esse prazo você cairá na tela de login e vai precisar entrar novamente. "))
          ]))
        : (confirmacaoVolta.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(confirmacaoVolta.value), 1))
          : _createCommentVNode("", true)
    ], 512),
    (_unref(authStore).acessandoComo)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "voltar",
          disabled: voltando.value,
          onClick: voltar
        }, _toDisplayString(voltando.value ? 'Voltando…' : 'Voltar a ser eu'), 9, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref_key: "erroEl",
      ref: erroEl,
      class: _normalizeClass(["erro", { 'erro--visivel': !!erro.value }]),
      role: "alert",
      tabindex: "-1"
    }, _toDisplayString(erro.value), 3)
  ], 2))
}
}

})